export default {
    '发送': 'ส่ง',
    '1': 'สั่งสินค้าผิด',
    '2': 'คำสั่งซื้อซ้ำ',
    '3': 'ไม่สามารถรับสินค้าได้',
    '4': 'เหตุผลอื่น ๆ',
    '-连接已建立-': '-สร้างการเชื่อมต่อแล้ว-',
    ',才可提币': ', จึงจะถอนได้',
    '[code]值错误': 'ค่า [code] ไม่ถูกต้อง',
    '[symbol]参数为空': 'พารามิเตอร์ [symbol] ว่างเปล่า',
    homeDownloadtips41: 'แอปร้านค้า',
    '不能为空': 'ห้ามเว้นว่าง',
    '不在交易时段': 'ไม่อยู่ในช่วงเวลาซื้อขาย',
    '不在可提现时间内': 'ไม่อยู่ในช่วงเวลาถอนเงิน',
    '参数错误': 'พารามิเตอร์ผิดพลาด',
    '参数异常，消息获取失败': 'พารามิเตอร์ผิดปกติ ไม่สามารถดึงข้อความได้',
    '操作成功': 'ดำเนินการสำเร็จ',
    '操作类型不能小于0': 'ประเภทการดำเนินการต้องไม่น้อยกว่า 0',
    '操作类型不是整数': 'ประเภทการดำเนินการไม่ใช่จำนวนเต็ม',
    '操作类型为空': 'ประเภทการดำเนินการว่างเปล่า',
    '产品不存在': 'ไม่มีสินค้านี้',
    '产品剩余数量不足': 'จำนวนสินค้าคงเหลือไม่เพียงพอ',
    '承兑商不存在': 'ไม่มีผู้ค้ารายนี้',
    '程序错误': 'โปรแกรมผิดพลาด',
    '持有币种不足': 'สกุลเงินที่ถือครองไม่เพียงพอ',
    '充值价值不得大于最大限额': 'มูลค่าการเติมเงินต้องไม่เกินวงเงินสูงสุด',
    '充值价值不得小于最小限额': 'มูลค่าการเติมเงินต้องไม่ต่ำกว่าวงเงินขั้นต่ำ',
    '充值链错误': 'เชนการเติมเงินผิดพลาด',
    '充值数量不能小于等于0': 'จำนวนการเติมเงินต้องไม่น้อยกว่าหรือเท่ากับ 0',
    '存在不同杠杆的持仓单': 'มีสถานะที่มีเลเวอเรจต่างกัน',
    '存在重复的角色名称': 'มีชื่อบทบาทซ้ำกัน',
    '大于最大采购数量': 'มากกว่าจำนวนซื้อสูงสุด',
    '代理层级错误': 'ระดับตัวแทนผิดพลาด',
    '待付款的订单无法放行': 'คำสั่งซื้อที่รอชำระเงินไม่สามารถปล่อยได้',
    '当前地址格式错误': 'รูปแบบที่อยู่ปัจจุบันไม่ถูกต้อง',
    '当前订单不为待付款状态，无法取消': 'คำสั่งซื้อไม่อยู่ในสถานะรอชำระเงิน ไม่สามารถยกเลิกได้',
    '当前还需交易': 'ยังต้องทำการซื้อขายเพิ่มเติม',
    '当日才可申购': 'สามารถจองซื้อได้เฉพาะวันเดียวกันเท่านั้น',
    '当日可提现次数不足': 'จำนวนครั้งการถอนเงินวันนี้ไม่เพียงพอ',
    '登陆密码不符合设定': 'รหัสผ่านเข้าสู่ระบบไม่ตรงตามข้อกำหนด',
    '登陆密码长度不符合设定': 'ความยาวรหัสผ่านเข้าสู่ระบบไม่ตรงตามข้อกำหนด',
    '登录过期，请重新登录': 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง',
    '登录密码必须6-12位': 'รหัสผ่านเข้าสู่ระบบต้องมี 6-12 ตัวอักษร',
    '登录密码不能为空': 'รหัสผ่านเข้าสู่ระบบห้ามเว้นว่าง',
    '登录失败': 'เข้าสู่ระบบล้มเหลว',
    '电话号码已绑定': 'หมายเลขโทรศัพท์ถูกผูกไว้แล้ว',
    '电话号码已绑定其他用户': 'หมายเลขโทรศัพท์ถูกผูกกับผู้ใช้อื่นแล้ว',
    '订单不存在': 'ไม่มีคำสั่งซื้อนี้',
    '订单已取消': 'ยกเลิกคำสั่งซื้อแล้ว',
    '订单已取消，无法放行': 'ยกเลิกคำสั่งซื้อแล้ว ไม่สามารถปล่อยได้',
    '订单已完成，无法放行': 'คำสั่งซื้อเสร็จสิ้นแล้ว ไม่สามารถปล่อยได้',
    '发现新版本，请升级到最新版本': 'พบเวอร์ชันใหม่ กรุณาอัปเดตเป็นเวอร์ชันล่าสุด',
    '服务器错误': 'เซิร์ฟเวอร์ผิดพลาด',
    '服务器错误(500)': 'เซิร์ฟเวอร์ผิดพลาด (500)',
    '该产品未上架': 'สินค้านี้ยังไม่ได้วางจำหน่าย',
    '该产品已上市，无法购买': 'สินค้านี้วางจำหน่ายแล้ว ไม่สามารถซื้อได้',
    '该订单已取消': 'คำสั่งซื้อนี้ถูกยกเลิกแล้ว',
    '该广告剩余数量不足': 'จำนวนคงเหลือของโฆษณานี้ไม่เพียงพอ',
    '该基金尚未开放购买': 'กองทุนนี้ยังไม่เปิดให้ซื้อ',
    '该基金尚已封闭': 'กองทุนนี้ปิดแล้ว',
    '该邮箱已被订阅': 'อีเมลนี้สมัครรับข้อมูลแล้ว',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'รูปแบบไม่ถูกต้อง: จำนวนเงินเติมต้องไม่น้อยกว่า 1 (ทศนิยม 2 ตำแหน่ง)',
    '跟单倍数输入错误': 'ป้อนตัวคูณ copy trading ไม่ถูกต้อง',
    '跟单参数输入错误': 'ป้อนพารามิเตอร์ copy trading ไม่ถูกต้อง',
    '更新提醒': 'การแจ้งเตือนการอัปเดต',
    '工作地址不能为空': 'ที่อยู่ที่ทำงานห้ามเว้นว่าง',
    '购买矿机时间不得低于托管订单剩余时间': 'ระยะเวลาซื้อเครื่องขุดต้องไม่น้อยกว่าเวลาคงเหลือของคำสั่งโฮสติ้ง',
    '广告不存在': 'ไม่มีโฆษณานี้',
    '广告已下架': 'โฆษณาถูกนำออกแล้ว',
    '基金剩余购买金额不足': 'จำนวนเงินซื้อกองทุนคงเหลือไม่เพียงพอ',
    '家庭地址不能为空': 'ที่อยู่บ้านห้ามเว้นว่าง',
    '交易员不存在': 'ไม่มีเทรดเดอร์นี้',
    '交易员不能跟随自己': 'เทรดเดอร์ไม่สามารถติดตามตนเองได้',
    '交易员跟随人数已满': 'จำนวนผู้ติดตามเทรดเดอร์เต็มแล้ว',
    '交易员未开启带单': 'เทรดเดอร์ยังไม่ได้เปิด copy trading',
    '交易员无法跟随另一个交易员': 'เทรดเดอร์ไม่สามารถติดตามเทรดเดอร์คนอื่นได้',
    '角色被用户关联，不可删除': 'บทบาทถูกผูกกับผู้ใช้ ไม่สามารถลบได้',
    '角色不存在': 'ไม่มีบทบาทนี้',
    '金额不在购买区间': 'จำนวนเงินไม่อยู่ในช่วงการซื้อ',
    '金额错误': 'จำนวนเงินผิดพลาด',
    '旧密码不能为空': 'รหัสผ่านเดิมห้ามเว้นว่าง',
    '旧密码不正确': 'รหัสผ่านเดิมไม่ถูกต้อง',
    '可平仓合约张数不足': 'จำนวนสัญญาที่ปิดได้ไม่เพียงพอ',
    '矿机不存在': 'ไม่มีเครื่องขุดนี้',
    '矿机未解锁，无法购买': 'เครื่องขุดยังไม่ปลดล็อก ไม่สามารถซื้อได้',
    '历史基金无法购买': 'ไม่สามารถซื้อกองทุนในอดีตได้',
    '连续输入错误三次，请3分钟后再试': 'ป้อนผิดติดต่อกัน 3 ครั้ง กรุณาลองใหม่ใน 3 นาที',
    '领取成功': 'รับสำเร็จ',
    '买入金额需要在区间内': 'จำนวนเงินซื้อต้องอยู่ในช่วง',
    '卖方无法取消该订单': 'ผู้ขายไม่สามารถยกเลิกคำสั่งซื้อนี้ได้',
    '没有找到用户': 'ไม่พบผู้ใช้',
    verificationCode: 'รหัสยืนยัน',
    pleaseEnterVerificationCode: 'กรุณากรอกรหัสยืนยัน',
    pleaseEnterUsername: 'กรุณากรอกชื่อผู้ใช้',
    username: 'ชื่อผู้ใช้',
    getVerificationCode: 'รับรหัส',
    tryAgainLater: 'วินาทีจึงลองใหม่ได้',
    '密码必须6-12位': 'รหัสผ่านต้องมี 6-12 ตัวอักษร',
    '密码不能为空': 'รหัสผ่านห้ามเว้นว่าง',
    '密码不正确': 'รหัสผ่านไม่ถูกต้อง',
    '您当前可分配额度不足': 'วงเงินที่จัดสรรได้ในปัจจุบันไม่เพียงพอ',
    '您没有符合条件的收款方式': 'คุณไม่มีวิธีรับเงินที่ตรงตามเงื่อนไข',
    '您已存在订单': 'คุณมีคำสั่งซื้ออยู่แล้ว',
    '您已购买过体验矿机,不得重复购买': 'คุณซื้อเครื่องขุดทดลองไปแล้ว ไม่สามารถซื้อซ้ำได้',
    '亲属地址不能为空': 'ที่อยู่ญาติห้ามเว้นว่าง',
    '亲属电话不能为空': 'โทรศัพท์ญาติห้ามเว้นว่าง',
    '亲属关系不能为空': 'ความสัมพันธ์ญาติห้ามเว้นว่าง',
    '亲属姓名不能为空': 'ชื่อญาติห้ามเว้นว่าง',
    '请检查网络连接': 'กรุณาตรวจสอบการเชื่อมต่อเครือข่าย',
    '请上传图片': 'กรุณาอัปโหลดรูปภาพ',
    '请稍后再试': 'กรุณาลองใหม่ภายหลัง',
    '请稍后重试': 'กรุณาลองใหม่ภายหลัง',
    '请输入充值币种': 'กรุณากรอกสกุลเงินที่เติม',
    '请输入内容': 'กรุณากรอกเนื้อหา',
    '请输入搜索关键字': 'กรุณากรอกคำค้นหา',
    '请输入正确的货币数量': 'กรุณากรอกจำนวนสกุลเงินที่ถูกต้อง',
    '请输入正确的金额': 'กรุณากรอกจำนวนเงินที่ถูกต้อง',
    '请输入正确的数量': 'กรุณากรอกจำนวนที่ถูกต้อง',
    '请输入正确的质押金额': 'กรุณากรอกจำนวนเงิน staking ที่ถูกต้อง',
    '请输入正确的质押天数': 'กรุณากรอกจำนวนวัน staking ที่ถูกต้อง',
    '请填写正确的电话号码': 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    '请填写正确的验证码': 'กรุณากรอกรหัสยืนยันที่ถูกต้อง',
    '请填写正确的邮箱地址': 'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
    '请先绑定谷歌验证器': 'กรุณาผูก Google Authenticator ก่อน',
    '请先添加收款方式': 'กรุณาเพิ่มวิธีรับเงินก่อน',
    '请先通过高级认证': 'กรุณาผ่านการยืนยันขั้นสูงก่อน',
    '请选择买卖方式': 'กรุณาเลือกวิธีซื้อขาย',
    '请选择正确的币种': 'กรุณาเลือกสกุลเงินที่ถูกต้อง',
    '请重新登录': 'กรุณาเข้าสู่ระบบอีกครั้ง',
    '渠道未开通': 'ยังไม่ได้เปิดช่องทาง',
    '取消': 'ยกเลิก',
    '确认': 'ยืนยัน',
    '申购数量错误': 'จำนวนการจองซื้อผิดพลาด',
    '申请成功': 'ยื่นคำขอสำเร็จ',
    '身份证已实名过!': 'บัตรประชาชนยืนยันตัวตนแล้ว!',
    '审核已通过': 'ผ่านการตรวจสอบแล้ว',
    '审核中': 'กำลังตรวจสอบ',
    '实名认证未通过，无法进行高级认证': 'การยืนยันตัวตนไม่ผ่าน ไม่สามารถทำการยืนยันขั้นสูงได้',
    '收款方输入错误': 'ป้อนผู้รับเงินไม่ถูกต้อง',
    '授权状态未成功': 'สถานะการอนุญาตไม่สำเร็จ',
    '赎回状态异常': 'สถานะการไถ่ถอนผิดปกติ',
    '所选汇率不存在': 'ไม่มีอัตราแลกเปลี่ยนที่เลือก',
    '提币数量不能小于等于0': 'จำนวนการถอนต้องไม่น้อยกว่าหรือเท่ากับ 0',
    '提交失败，当前有未处理订单': 'ส่งล้มเหลว มีคำสั่งซื้อที่ยังไม่ได้ดำเนินการ',
    '提示': 'แจ้งเตือน',
    '提现不得大于限额': 'การถอนต้องไม่เกินวงเงิน',
    '提现不得小于限额': 'การถอนต้องไม่ต่ำกว่าวงเงิน',
    '图片不得大于10M': 'รูปภาพต้องไม่เกิน 10 MB',
    '图片不得大于2M': 'รูปภาพต้องไม่เกิน 2 MB',
    '图片大小不能超过2M！': 'ขนาดรูปภาพต้องไม่เกิน 2 MB!',
    '图片上传失败': 'อัปโหลดรูปภาพล้มเหลว',
    '推荐码不正确': 'รหัสแนะนำไม่ถูกต้อง',
    '推荐人无权限推荐': 'ผู้แนะนำไม่มีสิทธิ์แนะนำ',
    '委托数量(张)必填': 'จำนวนคำสั่ง (สัญญา) จำเป็นต้องกรอก',
    '委托数量(张)不能小于等于0': 'จำนวนคำสั่ง (สัญญา) ต้องไม่น้อยกว่าหรือเท่ากับ 0',
    '未绑定谷歌验证器': 'ยังไม่ได้ผูก Google Authenticator',
    '未绑定手机号': 'ยังไม่ได้ผูกหมายเลขโทรศัพท์',
    '未绑定邮箱': 'ยังไม่ได้ผูกอีเมล',
    '未发现授权记录': 'ไม่พบบันทึกการอนุญาต',
    '未实名认证，是否认证？': 'ยังไม่ยืนยันตัวตน ต้องการยืนยันหรือไม่?',
    '未授权访问': 'การเข้าถึงที่ไม่ได้รับอนุญาต',
    '未找到符合条件的匹配订单': 'ไม่พบคำสั่งซื้อที่ตรงเงื่อนไข',
    '未找到匹配的收益记录': 'ไม่พบบันทึกรายได้ที่ตรงกัน',
    myComment: 'รีวิวของฉัน',
    myPoint: 'คะแนนของฉัน',
    accountInfo: 'ข้อมูลบัญชี',
    myBalance: 'ยอดเงินของฉัน',
    myCoupon: 'คูปองของฉัน',
    unused: 'ยังไม่ใช้',
    used: 'ใช้แล้ว',
    expired: 'หมดอายุ',
    expires: 'ใช้ได้ถึง',
    minSpend: 'ขั้นต่ำ',
    availableBalance: 'ยอดเงินที่ใช้ได้',
    personalDeposit: 'ยอดเงิน',
    useDepositBalance: 'ใช้ยอดเงินหักลด',
    depositDeduct: 'หักจากยอดเงิน',
    useMaxDeposit: 'หักเต็มจำนวน',
    balanceHistory: 'ประวัติยอดเงิน',
    recordCount: 'รวม {count} รายการ',
    depositType: 'ประเภทธุรกรรม',
    balanceAfter: 'ยอดคงเหลือ',
    depositTypeRecharge: 'เติมยอดเงิน',
    depositTypeAdjustment: 'ปรับยอดเงิน',
    depositTypeOrderPayment: 'ชำระคำสั่งซื้อ',
    depositTypeOrderRefunds: 'คืนเงินคำสั่งซื้อ',
    depositTypeDistributionCommission: 'ค่าคอมมิชชันการจัดจำหน่าย',
    depositTypeDistributionWithdrawal: 'ถอนเงินการจัดจำหน่าย',
    depositTypeOther: 'อื่น ๆ',
    income: 'รายรับ',
    expense: 'รายจ่าย',
    description: 'คำอธิบาย',
    myFootprint: 'ประวัติการเข้าชมของฉัน',
    '无权限': 'ไม่มีสิทธิ์',
    '无效的UID': 'UID ไม่ถูกต้อง',
    '系统参数错误': 'พารามิเตอร์ระบบผิดพลาด',
    '系统存在相同[系统登录名]！': 'ระบบมี [ชื่อเข้าสู่ระบบ] เดียวกันอยู่แล้ว!',
    '系统错误，请稍后重试': 'ระบบผิดพลาด กรุณาลองใหม่ภายหลัง',
    '下单不能小于最小金额限制': 'คำสั่งซื้อต้องไม่น้อยกว่าจำนวนเงินขั้นต่ำ',
    '校验IP不合法': 'IP ตรวจสอบไม่ถูกต้อง',
    '新密码不能为空': 'รหัสผ่านใหม่ห้ามเว้นว่าง',
    '新密码不一致': 'รหัสผ่านใหม่ไม่ตรงกัน',
    '新密码确认不能为空': 'การยืนยันรหัสผ่านใหม่ห้ามเว้นว่าง',
    '行情获取异常，稍后再试': 'ดึงข้อมูลราคาตลาดล้มเหลว กรุณาลองใหม่ภายหลัง',
    '验证类型不能为空': 'ประเภทการยืนยันห้ามเว้นว่าง',
    '验证码不能为空': 'รหัสยืนยันห้ามเว้นว่าง',
    '验证码不正确': 'รหัสยืนยันไม่ถูกต้อง',
    '验证码错误': 'รหัสยืนยันผิดพลาด',
    '页码不能小于等于0': 'หมายเลขหน้าต้องไม่น้อยกว่าหรือเท่ากับ 0',
    '页码不是整数': 'หมายเลขหน้าไม่ใช่จำนวนเต็ม',
    '已领取': 'รับแล้ว',
    '用户不存在': 'ไม่มีผู้ใช้นี้',
    '用户名必须由数字和英文字母组成': 'ชื่อผู้ใช้ต้องประกอบด้วยตัวเลขและตัวอักษรละติน',
    '用户名不存在': 'ไม่มีชื่อผู้ใช้นี้',
    '用户名不符合设定': 'ชื่อผู้ใช้ไม่ตรงตามข้อกำหนด',
    '用户名不能为空': 'ชื่อผู้ใช้ห้ามเว้นว่าง',
    '用户名参数为空': 'พารามิเตอร์ชื่อผู้ใช้ว่างเปล่า',
    '用户名重复': 'ชื่อผู้ใช้ซ้ำ',
    '用户剩余数量不足': 'จำนวนผู้ใช้คงเหลือไม่เพียงพอ',
    '用户已跟随交易员': 'ผู้ใช้ติดตามเทรดเดอร์แล้ว',
    '邮箱已绑定': 'อีเมลถูกผูกแล้ว',
    '邮箱已绑定其他用户': 'อีเมลถูกผูกกับผู้ใช้อื่นแล้ว',
    '余额不足': 'ยอดเงินไม่เพียงพอ',
    shop_order_insufficientBalance: 'ยอดเงินในบัญชีไม่เพียงพอ',
    '帐户异常需要进行C3认证，请联系在线客服。': 'บัญชีผิดปกติ ต้องยืนยัน C3 กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์',
    '找不到用户': 'ไม่พบผู้ใช้',
    flashSale: 'แฟลชเซล',
    groupBuy: 'ซื้อแบบกลุ่ม',
    groupBuying: 'การซื้อแบบกลุ่ม',
    couponCenter: 'ศูนย์คูปอง',
    pointMall: 'ร้านค้าคะแนน',
    liveList: 'ไลฟ์สด',
    endsIn: 'สิ้นสุดใน',
    soldOut: 'ขายแล้ว',
    people: 'คน',
    joined: 'เข้าร่วมแล้ว',
    startGroup: 'เริ่มซื้อแบบกลุ่ม',
    getCoupon: 'รับ',
    '直线关系，不能修改推荐': 'ความสัมพันธ์โดยตรง ไม่สามารถแก้ไขผู้แนะนำได้',
    '重复提交': 'ส่งซ้ำ',
    '转账币种不能为空': 'สกุลเงินโอนห้ามเว้นว่าง',
    '转账数量不能小于等于0': 'จำนวนเงินโอนต้องไม่น้อยกว่าหรือเท่ากับ 0',
    '状态不能小于0': 'สถานะต้องไม่น้อยกว่า 0',
    '状态不是整数': 'สถานะไม่ใช่จำนวนเต็ม',
    '资金密码必须6-12位': 'รหัสผ่านเงินทุนต้องมี 6-12 ตัวอักษร',
    '资金密码不符合设定': 'รหัสผ่านเงินทุนไม่ตรงตามข้อกำหนด',
    '资金密码不能为空': 'รหัสผ่านเงินทุนห้ามเว้นว่าง',
    '资金密码错误': 'รหัสผ่านเงินทุนผิดพลาด',
    '资金密码长度不符合设定': 'ความยาวรหัสผ่านเงินทุนไม่ตรงตามข้อกำหนด',
    'UID不能为空': 'UID ห้ามเว้นว่าง',
    required: 'จำเป็นต้องกรอก',
    nickname: 'ชื่อเล่น',
    enterNickname: 'กรุณากรอกชื่อเล่น',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    secret: 'ไม่ระบุ',
    birthday: 'วันเกิด',
    selectDate: 'เลือกวันที่',
  cancelOrderMap: {
    0: "ฉันไม่ต้องการมัน",
    1: "วางผลิตภัณฑ์ผิดที่",
    2: "คำสั่งซื้อซ้ำ",
    3: "การรับล้มเหลว",
    4: "เหตุผลอื่น ๆ",
  },
  "当前余额": "ยอดคงเหลือปัจจุบัน",
  "请选择": "กรุณาเลือก",
  "备注": "หมายเหตุ",
  "获取验证码": "รหัสผ่าน",
  "验证码": "รหัสผ่าน",
  "请输入验证码": "กรุณากรอกรหัสผ่าน",
  "验证码": "รหัสผ่าน",
  "已发送，请注意查收": "ถูกส่งแล้ว กรุณาตรวจสอบ",
  "仅能绑定一个收款地址!": "สามารถผูกที่อยู่รับเงินได้เพียงหนึ่งที่!",
  "绑定成功": "ผูกสำเร็จ",
  "提款地址绑定": "ผูกที่อยู่ถอน",
  "电商批发商场": "ตลาดผู้ค้าส่งออนไลน์",
  "请输入完整的支付密码!" : "กรุณาใส่รหัสผ่านการชำระเงินทั้งหมด!",
  "用户未发表评论": "ผู้ใช้ไม่ได้แสดงความคิดเห็น",
  "订单": "คำสั่ง",
  "下单成功，等待付款": "สั่งซื้อสำเร็จ รอการชำระเงิน",
  "下单成功，付款成功": "สั่งซื้อสำเร็จ ชำระเงินสำเร็จ",
  "已发货，正在运输中": "จัดส่งในการขนส่ง",
  "订单已取消，原因:手动发起取消订单": "คำสั่งซื้อถูกยกเลิก เหตุผล: ยกเลิกคำสั่งซื้อด้วยตนเอง",
  "订单已取消，原因:超时自动取消订单": "คำสั่งซื้อถูกยกเลิก เหตุผล: คำสั่งซื้อจะถูกยกเลิกโดยอัตโนมัติเมื่อหมดเวลา",
  "商家已确认，已进入备货状态": "ผู้ค้าได้รับการยืนยันและเข้าสู่สถานะสต็อกแล้ว",
  "系统发货成功": "การส่งมอบระบบสำเร็จ",
  "订单已签收": "ได้รับคำสั่งซื้อแล้ว",
  "发起退款申请": "เริ่มการขอคืนเงิน",
  "退款成功": "การคืนเงินสำเร็จ",
  "退款失败": "การคืนเงินล้มเหลว",
  "订单退款成功": "การคืนเงินของคำสั่งซื้อสำเร็จ",
  "订单退款失败": "การคืนเงินคำสั่งซื้อล้มเหลว",
  "系统默认好评": "ระบบตั้งค่าเริ่มต้นเป็นบทวิจารณ์ที่ดี",
  "请输入关键字搜索": "กรุณาใส่คีย์เวิร์ดเพื่อค้นหา",
  "猜你喜欢": "เดาว่าคุณชอบมัน",
  "订单已完成": "การสั่งซื้อเสร็จสมบูรณ์",
  "热销推荐": "คำแนะนำการขายร้อน",
  "头像选择": "การเลือกอวาตาร์",
  "修改头像": "ปรับเปลี่ยนอวาตาร์ของคุณ",
  subOrder: "ส่งคำสั่งซื้อ",
  "mailboxCheck": "กรุณากรอกที่อยู่อีเมลให้ถูกต้อง",
  "switchLang": "โปรดเปลี่ยนไปใช้ภาษาอื่นเพื่อดู",
  "myCart": "รถเข็นของฉัน",
  "notQua": "ไม่ตรงตามเงื่อนไขคุณสมบัติ",
  "noSmaller": "จำนวนเงินที่สมัครต้องไม่ต่ำกว่า",
  "nomax": "จำนวนการสมัครสูงสุดต้องไม่เกิน",
  "evaluationUploading": "คุณยังมีรูปภาพที่กำลังอัปโหลดอยู่ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "evaluateInput": "รีวิวด้วยภาพ",
  "moneyOrderStatus": "สถานะการสั่งซื้อ",
  "coinBlock": "ข้อตกลงสกุลเงิน",
  "dealing": "อยู่ในขั้นตอน",
  "dealSuccess": "ประสบความสำเร็จ",
  "dealFail": "ล้มเหลว",
  "payCertificate": "ใบสำคัญจ่าย",
  "handleFee": "ค่าบริการ",
  "highOpinion": "บทวิจารณ์ที่ดี",
  "mediumOpinion": "รีวิวปานกลาง",
  "lowOpinion": "ความคิดเห็นที่ไม่ดี",
  "hasImage": "ด้วยรูปภาพ",
  "rechargeMethod": "โหมดเติมเงิน",
  "scanAndDown": "สแกน QR Code ดาวน์โหลด APP",
  "receivedAddress": "ที่อยู่ใบเสร็จรับเงิน",
  "ActualLedger": "ใบเสร็จรับเงินจริง",
  "view": "ดู",
  "withdrawNum": "ปริมาณการถอนเงินสด",
  "rechargeNum": "ปริมาณการเติมเงิน",
  "date": "วันที่",
  "walletHistory": "ประวัติกระเป๋าเงิน",
  "accountBalance": "ยอดเงินในบัญชี",
  "accountReview": "ภาพรวมบัญชี",
  "rated": "ตรวจสอบแล้ว",
  "receiver": "เครื่องรับ",
  "orderStatus": "สถานะ",
  "orderTime": "เวลา",
  "tax": "การจัดเก็บภาษี",
  "discount": "การลดราคา",
  "productInfo": "ข้อมูลผลิตภัณฑ์",
  "paramError": "ข้อผิดพลาดของพารามิเตอร์",
  "orderInfo": "ข้อมูลการสั่งซื้อ",
  "rebuy": "อีกหนึ่งออเดอร์",
  "pleaseCorrectAddress": "กรุณากรอกที่อยู่ในการเบิกถอนเงินสดให้ถูกต้อง",
  "pleaseInputCorrectNumber": "กรุณาใส่ตัวเลขที่มากกว่า 0",
  "vcodePass": "ผ่านการตรวจสอบแล้ว!",
  "vcodeFail": "การตรวจสอบสิทธิ์ล้มเหลว โปรดลองอีกครั้ง",
  "uploading": "กำลังอัปโหลด...",
  "uploadSuccess": "อัปโหลดสำเร็จ",
  "uploadError": "การอัพโหลดล้มเหลว. กรุณาลองอีกครั้ง",
  "registerSuccess": "ลงทะเบียนสำเร็จ",
  "pleaseSetMobileNumber": "กรุณาตั้งหมายเลขโทรศัพท์",
  "unSelectedProduct": "คุณยังไม่ได้เลือกผลิตภัณฑ์",
  "loginSuccess": "เข้าสู่ระบบสำเร็จ",
  "pleaseSetAreaCode": "ใส่ชื่อประเทศและรหัสพื้นที่เพื่อค้นหา",
  "login": "เข้าสู่ระบบ",
  "register": "ทะเบียน",
  "logout": "ทางออก",
  "noData": "ไม่พบข้อมูล",
  "search": "ค้นหา",
  "historySearch": "การค้นหาทางประวัติศาสตร์",
  "empty": "ว่างเปล่า",
  "home": "หน้าแรก",
  "favorableRate": "อัตราความคิดเห็นที่ดี",
  "classification": "หมวดหมู่",
  "searchTips": "ค้นหาแหล่งที่มา/สินค้า/ซัพพลายเออร์/คำสั่งซื้อ",
  "dailyNewArrival": "รายการผลิตภัณฑ์ใหม่ทุกวัน",
  "more": "มากกว่า",
  "recommend": "คำแนะนำ",
  "recommendedProducts": "สินค้าแนะนำ",
  "recommendedStore": "ร้านค้าแนะนำ",
  "buyNow": "สั่งซื้อตอนนี้",
  "addCart": "เพิ่มในตะกร้าสินค้า",
  "complex": "แบบบูรณาการ",
  "price": "ราคา",
  "retailPrice": "ราคาขายปลีก",
  "originPrice": "ราคาเดิม",
  "service": "บริการลูกค้า",
  "collect": "รายการโปรด",
  "sold": "ปริมาณการขาย",
  "pageviews": "จำนวนการเรียกดู",
  "quantity": "ปริมาณ",
  "freight": "สินค้า",
  "shipping": "การส่งสินค้า",
  "ship": "เรือ",
  "buyTips": "จัดส่งภายใน 24 ชั่วโมงหลังจากทำการสั่งซื้อ คำสั่งซื้อต่อไปนี้อยู่ภายใต้การควบคุมของลอจิสติกส์และอาจจัดส่งล่าช้า โปรดใส่ใจกับข้อมูลโลจิสติกส์หรือติดต่อฝ่ายบริการลูกค้า",
  "totalPrice": "ราคารวม",
  "addCartMessage": "เพิ่มไปยังตะกร้าสินค้าเรียบร้อยแล้ว",
  "addCartMessageFaild": "สินค้ามีอยู่แล้วในตะกร้าสินค้า",
  "myAccount": "บัญชีของฉัน",
  "buyHistory": "บันทึกการซื้อ",
  "wishlist": "สินค้าที่ชื่นชอบ",
  "trackOrder": "คำสั่ง",
  "account": "บัญชี:",
  "sellerZone": "พื้นที่ค้าขาย",
  "beSeller": "มาเป็นพ่อค้า",
  "sellerPanelLogin": "เข้าสู่ระบบร้านค้า",
  "footTip": "© ลิขสิทธิ์ {name} Ltd 2024",
  "footTips": "{name} Limited ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority ในฐานะนายหน้าสินเชื่อ (713206) และตกลงเฉพาะกับผู้ให้กู้ Home Retail Group CardServices Limited ในฐานะ {name} Financial Services {name} Financial Services ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority เพื่อให้เครดิต (716148) Home Retail GroupCard Services Limited จดทะเบียนในสหราชอาณาจักร (04007072) ที่ Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom MK9 2NW.",
  "item": "บทความ",
  "checkout": "สั่งซื้อสินค้า",
  "productDescription": "รายละเอียดสินค้า",
  "userEvaluation": "ความคิดเห็นของผู้ใช้",
  "AllProducts": "สินค้าทั้งหมด",
  "followers": "ติดตาม",
  "sales": "ปริมาณการขาย",
  "visitStore": "เยี่ยมชมร้านค้า",
  "authentic": "ของแท้ 100%",
  "dayReturns7": "7 วันกลับ",
  "shippingDiscounts": "ส่วนลดค่าขนส่ง",
  "safePayment": "การชำระเงินที่ปลอดภัย",
  "followed": "ตามมา",
  "dashboard": "แผงเครื่องมือ",
  "myOrder": "คำสั่งของฉัน",
  "setUp": "ติดตั้ง",
  "successTips": "ประสบความสำเร็จ",
  "copySuccess": "การจำลองแบบสำเร็จ",
  "balance": "ยอดคงเหลือ (USDT)",
  "sort": "พิมพ์",
  "commodity": "ผลิตภัณฑ์",
  "browse": "ปริมาณการขาย",
  "recharge": "เติมเงิน",
  "commodityCollection": "การรวบรวมผลิตภัณฑ์",
  "withdraw": "ถอนเงินสด",
  "defaultAddress": "ที่อยู่เริ่มต้น",
  "addNewAddress": "เพิ่มที่อยู่ใหม่",
  "withdrawRecord": "บันทึกการถอนเงินสด",
  "serialNumber": "เลขที่ใบสั่งซื้อ",
  "time": "เวลา",
  "amount": "จำนวน",
  "processing": "อยู่ในขั้นตอน",
  "fail": "ล้มเหลว",
  "blockchainNetwork": "เครือข่ายบล็อกเชน",
  "records": "บันทึก",
  "withdrawAddress": "ที่อยู่ถอนเงินสด",
  "withdrawInputTips": "กรุณากรอกที่อยู่ในการถอนเงิน",
  "copy": "การจำลองแบบ",
  "enterTips": "กรุณาป้อน",
  "actualAccount": "บัญชีจริง",
  "handlingFee": "ค่าบริการ",
  "confirm": "ยืนยันการรับสินค้า",
  "previous": "ขั้นตอนก่อนหน้า",
  "pleaseEnterAddress": "กรุณากรอกที่อยู่",
  "pleaseEnterQuantity": "กรุณาใส่จำนวน",
  "withdrawSuccess": "ส่งคำสั่งซื้อสำเร็จแล้ว",
  "saveQr": "บันทึกคิวอาร์โค้ด",
  "pleaseEnterAmount": "กรุณากรอกจำนวนเงินที่เติม",
  "expectedArrival": "การมาถึงที่คาดว่าจะมาถึง",
  "currentRate": "อัตราแลกเปลี่ยนปัจจุบัน",
  "uploadTips": "หลักฐานการชำระเงิน (อัพโหลดภาพหน้าจอรายละเอียดการชำระเงิน)",
  "clickUpload": "คลิกเพื่ออัปโหลด",
  "uploadPhoto": "กรุณาอัปโหลดรูปถ่าย",
  "rechargeSuccessful": "เติมเงินสำเร็จ",
  "rechargeTips": "\"การแจ้งการเติมเงิน: \"\"กรุณากรอกจำนวนเงินที่โอนจริงตามความเป็นจริง มิฉะนั้น ระบบอาจไม่ผ่านการอนุมัติและส่งผลต่อความคืบหน้าในการเติมเงิน\"",
  "rechargeRecord": "บันทึกการเติมเงิน",
  "all": "ทั้งหมด",
  "pending": "ที่จะต้องจ่าย",
  "cancelled": "ยกเลิก",
  "delivered": "ที่จะจัดส่ง",
  "confirmed": "ยืนยัน",
  "receipt": "ที่จะได้รับ",
  "harvested": "ได้รับ",
  "comment": "ที่จะได้รับการตรวจสอบ",
  "refund": "การคืนเงิน/หลังการขาย",
  "cancelOrder": "ยกเลิกคำสั่งซื้อ",
  "cancelReason": "เหตุผลในการยกเลิก",
  "cancelOrderTitle": "โปรดเลือกเหตุผลในการยกเลิกคำสั่งซื้อ",
  "returnOrderTitle": "โปรดเลือกเหตุผลในการคืนสินค้า",
  "refundInstructions": "คำแนะนำในการคืนเงิน",
  "returnDetailTips": "กรุณาให้ความคิดเห็นเกี่ยวกับผลิตภัณฑ์",
  "cancel": "ยกเลิกคำสั่งซื้อ",
  "cancelOrder1": "ไม่ได้รับสินค้า",
  "cancelOrder2": "ไม่ชอบก็ไม่อยากได้",
  "cancelOrder3": "ผู้ขายส่งสินค้าผิด",
  "cancelOrder4": "ยี่ห้อปลอม",
  "cancelOrder5": "ส่งน้อย พลาดส่ง",
  "cancelOrder6": "ได้รับสินค้าเสียหาย",
  "cancelOrder7": "มีปัญหาด้านคุณภาพ",
  "cancelOrder8": "เจรจาคืนเงินกับผู้ขาย",
  "cancelOrder9": "เหตุผลอื่น ๆ",
  "cancelOrderSuccess": "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว",
  "returnOrderSuccess": "ส่งสำเร็จ",
  "orderName": "ชื่อ",
  "orderEmail": "อีเมล",
  "orderAddress": "ที่อยู่",
  "orderNation": "ประเทศ",
  "orderState": "สถานะ",
  "orderCity": "เมือง",
  "orderPostCode": "รหัสไปรษณีย์",
  "orderAmount": "ปริมาณ",
  "orderPrefix": "ยอดสั่งซื้อ",
  "orderFee": "ภาษี",
  "orderSpecification": "ข้อมูลจำเพาะ",
  "orderCommodity": "ผลิตภัณฑ์",
  "orderQuantity": "ปริมาณ",
  "orderUnitprice": "ราคาต่อหน่วย",
  "orderFreight": "สินค้า",
  "orderTax": "ภาษี",
  "orderTotal": "ทั้งหมด",
  "PaymentOrder": "สั่งจ่าย",
  "Evaluate": "ทบทวน",
  "CancelOrder": "ยกเลิกคำสั่งซื้อ",
  "RemindShip": "เตือนสำหรับการจัดส่ง",
  "Refund": "คืนเงิน",
  "Submitareview": "ส่งความคิดเห็น",
  "Information": "ข้อมูล",
  "wrongPassword": "รหัสผ่านผิดพลาดมากกว่า 3 ครั้ง โปรดลองอีกครั้งในวันพรุ่งนี้",
  "Operate": "การดำเนินการ",
  "Item": "รายการ",
  "From": "จาก",
  "hint": "เคล็ดลับ",
  "CheckDetails": "ดูรายละเอียด",
  "Payment": "การชำระเงิน",
  "Cancel": "ยกเลิก",
  "refundSuccessfully": "การคืนเงินสำเร็จ",
  "pendingPayment": "ที่จะต้องจ่าย",
  "pay": "การชำระเงิน",
  "LoginPassword": "รหัสผ่านการเข้าใช้งาน",
  "sure": "แน่นอน",
  "shippingAddress": "ที่อยู่รับ",
  "transactionPassword": "รหัสผ่านการทำธุรกรรม",
  "markDefaultAddress": "ทำเครื่องหมายเป็นที่อยู่จัดส่งเริ่มต้น",
  "edit": "แก้ไขโดย",
  "delete": "ลบ",
  "Opt": "เลือก",
  "piece": "ชิ้น",
  "orderDetails": "รายละเอียดการสั่งซื้อ",
  "shopCollection": "เพิ่มร้านค้าในรายการโปรด",
  "addAddress": "เพิ่มที่อยู่ใหม่",
  "signUp": "ทะเบียน",
  "loginTips": "มีบัญชีอยู่แล้ว?",
  "loginIn": "เข้าสู่ระบบ",
  "mobile": "หมายเลขโทรศัพท์",
  '购物车还没有商品': 'ไม่มีสินค้าในรถเข็น',
  '去购物': 'ไปช็อปปิ้ง',
  "modifyAddress": "แก้ไขที่อยู่",
  "desc": "ตั้งเป็นที่อยู่เริ่มต้น",
  "keep": "บำรุงรักษา",
  "onlineService": "บริการออนไลน์",
  "send": "ส่ง",
  "EsShop": "ร้านค้าออนไลน์",
  "desc3": "ป้อนรหัสผ่านการทำธุรกรรม",
  "desc4": "ป้อนรหัสผ่านการทำธุรกรรมของคุณ",
  "desc6": "ป้อนรหัสผ่านการทำธุรกรรมของคุณอีกครั้ง",
  "setUpPayPaw": "ตั้งรหัสผ่านการทำธุรกรรม",
  "setSuccess": "ตั้งค่าสำเร็จ",
  "confirmPayPaw": "ยืนยันรหัสผ่านการทำธุรกรรม",
  "paymentSuccessful": "ชำระเงินสำเร็จ",
  "desc5": "ที่อยู่จัดส่งผิด? ติดต่อ",
  "customeService": "บริการลูกค้าออนไลน์",
  "BackHome": "กลับไปที่หน้าแรก",
  "Checkorder": "ดูคำสั่งซื้อ",
  "ForgotPassword": "ลืมรหัสผ่าน?",
  "signIn": "เข้าสู่ระบบ",
  "noAccount": "ไม่มีเลขที่บัญชี?",
  "pleaseEnterAccount": "กรุณากรอกเลขที่บัญชี",
  "pleaseEnterPassword": "กรุณาใส่รหัสผ่าน",
  "password": "รหัสผ่าน",
  "mobilePhone": "หมายเลขโทรศัพท์",
  "pleaseEnterPhoneNumer": "กรุณาตั้งหมายเลขโทรศัพท์",
  "setPassword": "ตั้งรหัสผ่าน",
  "noDataFound": "ไม่พบข้อมูล",
  "searchCountry": "ใส่ชื่อประเทศและรหัสพื้นที่เพื่อค้นหา",
  "pleaseEnterEmail": "กรุณาตั้งค่ากล่องจดหมาย",
  "invitationCode": "รหัสการเชิญ",
  "plaeseEnterInvitaionCode": "กรุณาตั้งรหัสเชิญ",
  "pleaseSetLoginPassword": "กรุณาตั้งรหัสผ่านเข้าสู่ระบบ",
  "selectDeliveryAddress": "เลือกที่อยู่ในการจัดส่ง",
  "totalOf": "ทั้งหมด",
  "items": "รายการ",
  "orderSummary": "สรุปการสั่งซื้อ",
  "paymentMethod": "วิธีการชำระเงิน",
  "Balance": "สมดุล",
  "payPal": "เพย์พาล",
  "notOpen": "วิธีการชำระเงินนี้ยังไม่เปิดในภูมิภาคของคุณ",
  "mastercard": "มาสเตอร์การ์ด",
  "additional": "พิเศษ",
  "handlingfee": "ต้องเสียค่าบริการ",
  "goodsNumber": "ปริมาณสินค้า",
  "deliveryFee": "ค่าขนส่ง",
  "totalNum": "ทั้งหมด",
  "new": "ใหม่",
  "oldPassword": "รหัสผ่านเก่า",
  "pleaseEnterOldPassword": "กรุณากรอกรหัสผ่านเดิม",
  "newPassword": "รหัสผ่านใหม่",
  "plaseeEnterNewPassword": "กรุณาใส่รหัสผ่านใหม่",
  "confirmPassword": "ยืนยันรหัสผ่าน",
  "plaseeENterConfirmPassword": "กรุณากรอกรหัสผ่านยืนยัน",
  "twoPawword": "รหัสผ่านสองตัวไม่เหมือนกัน",
  "rechargeAddress": "ที่อยู่เติมเงิน",
  "plaseEnterRechargeAddress": "กรุณากรอกที่อยู่สำหรับเติมเงิน",
  "userCenter": "ศูนย์ส่วนบุคคล",
  "merchantSettled": "รายการร้านค้า",
  "upNew": "รายการผลิตภัณฑ์ใหม่",
  "balanceNot": "ยอดเงินไม่เพียงพอ กรุณาเติมเงิน",
  "NoProductSelected": "สินค้ายังไม่ได้เลือก",
  "ShippingAddressNotSet": "ไม่ได้ตั้งค่าที่อยู่ในการจัดส่ง",
  "consigneeName": "ชื่อผู้รับ",
  "email": "อีเมล:",
  "areaCode": "รหัสพื้นที่ระหว่างประเทศ",
  "phoneNumber": "หมายเลขโทรศัพท์",
  "nation": "ประเทศ",
  "state": "จังหวัด/รัฐ/รัฐ",
  "city": "เมือง",
  "postCode": "รหัสไปรษณีย์",
  "address": "ที่อยู่โดยละเอียด",
  "addAddressOrModifyAddress": "เพิ่มที่อยู่ใหม่/แก้ไขที่อยู่",
  "setAsTheDefaultAddress": "ตั้งเป็นที่อยู่เริ่มต้น",
  "proceed": "ดำเนินการต่อ",
  "btnSure": "ยืนยัน",
  "pleaseInput": "กรุณาป้อน",
  "allProduct": "สินค้าทั้งหมด",
  "myCommodityCollection": "สินค้าที่ชื่นชอบ",
  "myFollowedShops": "ติดตามร้านค้า",
  "mySold": "ขายแล้ว",
  "myPageviews": "จำนวนการเรียกดู",
  "myPraiseRate": "อัตราความคิดเห็นที่ดี",
  "myUnfollow": "เลิกติดตาม",
  "inputNum": "ตัวเลข",
  "inpuEmailErro": "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง",
  "goodsShip": "การจัดส่ง",
  "goodsShipTips": "สินค้าจะถูกจัดส่งภายใน 24 ชั่วโมงหลังจากทำการสั่งซื้อ หากมีการควบคุมลอจิสติกส์สำหรับคำสั่งซื้อต่อไปนี้ คำสั่งซื้ออาจล่าช้า โปรดใส่ใจกับข้อมูลโลจิสติกของคำสั่งซื้อหรือติดต่อฝ่ายบริการลูกค้า",
  "goodsFreight": "ค่าขนส่ง",
  "goodsFreeShipping": "ไม่คิดเงิน",
  "goodsFreightTips1": "1. องค์ประกอบการขนส่งสินค้าข้ามพรมแดน: ค่าขนส่ง = ค่าธรรมเนียมการจัดส่ง + ค่าขนส่งทางไกล + ค่าธรรมเนียมการจัดส่ง",
  "goodsFreightTips2": "2. หากไม่ตรงตามเงื่อนไขของไปรษณีย์ จะคิดค่าขนส่งตามเงื่อนไขจริง",
  "goodsFreightTips3": "3. สิทธิ์ในการตีความขั้นสุดท้ายเป็นของแพลตฟอร์ม",
  "pleaseValidPostCode": "กรุณาใส่ตัวเลขมากกว่า 4 หลัก",
  "pleaseValidEmail": "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง",
  "pleaseValidPhone": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
  "productAvailable": "ผลิตภัณฑ์นี้ถูกลบออกแล้ว",
  "validatorMaxNumber": "จำนวนเงินเกินขีดจำกัด",
  "validatorRequire": "รายการที่จำเป็นต้องไม่เป็นโมฆะ",
  "validatorPhone": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง",
  "validatorEmail": "โปรดป้อนรูปแบบอีเมลที่ถูกต้อง",
  "validatorPassword": "รหัสผ่านประกอบด้วย 6-12 หลักหรือตัวอักษร(มีอักขระพิเศษ)",
  "validatorSixNumber": "กรุณาใส่ตัวเลข 6 หลัก",
  "validatorFourMoreNumber": "กรุณาใส่ตัวเลขหรือตัวอักษรรวมกัน 4-32 ตัว",
  "validatorIpRule": "รูปแบบ IP ไม่ถูกต้อง",
  "validatorChineseAndEnglish": "ภาษาจีนและภาษาอังกฤษเท่านั้น ช่วงการป้อน: 8-64 ตัวอักษร",
  "collectionSuccess": "เพิ่มในรายการโปรดสำเร็จ",
  "followedSuccess": "ติดตามสำเร็จ",
  "加值": "เพิ่มค่า",
  "平台人工发起退款": "เงินคืนที่เกิดจากการดำเนินการของผู้ขาย",
  "银行卡": "บัตรธนาคาร",
  "提领": "ถอน",
  "联系商家": "ติดต่อผู้ขาย",
  "cancelSuccess": "ยกเลิกสำเร็จ",
  "evaluateOrder": "รีวิวด้วยภาพ",
  "evaluateOrderPlaceholder": "กรุณาตรวจทานสินค้า",
  "operationSuccess": "การดำเนินการสำเร็จ",
  "confirmReceiveGoods": "ยืนยันการรับสินค้าหรือไม่",
  "evaluateOrderSuccess": "ตรวจสอบสำเร็จ",
  "yesterday": "เมื่อวาน",
  "notLogin": "คุณยังไม่ได้เข้าสู่ระบบ",
  "delAllHistoryRecord": "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกประวัติทั้งหมด",
  "or": "หรือ",
  "tipsRemindsText": "ผู้ค้าจะได้รับการแจ้งเตือนหลังจากเตือนการจัดส่งแล้ว",
  "tipsRemindsCount": "สามารถเตือนได้เพียงครั้งเดียวเท่านั้น",
  "tipsRemindsMerchant": "เตือนพ่อค้า",
  "tipsRemindsSuccess": "การแจ้งเตือนสำเร็จ",
  "noCartTips": "กระเป๋าช้อปปิ้งของคุณว่างเปล่า. เริ่มช้อปปิ้ง",
  "defaultRate": "ระบบตั้งค่าเริ่มต้นเป็นบทวิจารณ์ที่ดี",
  "prevPage": "หน้าก่อนหน้า",
  "nextPage": "หน้าต่อไป",
  "returnApply": "คำขอคืนเงิน",
  "returnReason": "เหตุผลในการคืนเงิน",
  "returnAmount": "คืนจำนวนเงิน",
  "returnRemark": "ส่งคืนคำแนะนำ",
  order: {
    cancel: "ยกเลิกคำสั่งซื้อ",
    payment: "จ่ายตอนนี้",
    remind: "เตือนสำหรับการจัดส่ง",
    return: "ขอคืนค่าสินค้า",
    evaluate: "รีวิวเลย",
    logistics: "ดูงานด้านโลจิสติกส์",
    noRefund: "ไม่คืนเงิน",
    refunding: "กำลังดำเนินการคืนเงิน",
    refundSuccess: "การคืนเงินสำเร็จ",
    refundFail: "การคืนเงินล้มเหลว",
    confirm: "ยืนยันการรับสินค้า",
    expressCompany: 'บริษัทขนส่ง',
    trackingNo: 'หมายเลขติดตาม',
    noOrderShipping: 'ไม่มีข้อมูลการจัดส่ง',
    noTransitSteps: 'ไม่มีข้อมูลการติดตาม',
    logisticsLoadFail: 'โหลดข้อมูลโลจิสติกส์ไม่สำเร็จ โปรดลองอีกครั้ง',
  },
  "remindTitle": "เตือนสำหรับการจัดส่ง",
  "remindContent": "หลังจากที่มีการเตือนการจัดส่ง ผู้ค้าจะได้รับการเตือน สามารถเตือนได้เพียงครั้งเดียวเท่านั้น",
  "remindSuccess": "การแจ้งเตือนสำเร็จ",
  "remindRepeat": "คำสั่งนี้ได้รับการเตือนแล้ว",
  "noComments": "ไม่มีการตรวจสอบในขณะนี้",
  "storeSeach": "ค้นหาสินค้าในร้านค้านี้",
  "storeSeachTips1": "พบสำหรับคุณ",
  "storeSeachTips2": "พบร้านค้าที่เกี่ยวข้อง",
  "storeSeachTips3": "บ้าน",
  "creditTit": "บริการสินเชื่อ",
  "getCoupons": "รับคูปองเพิ่มเติม",
  "yourEmail": "ที่อยู่อีเมลของคุณ",
  "subscription": "การสมัครรับข้อมูล",
  "paymethods": "วิธีการชำระเงิน",
  "footdec": "ผู้ใช้ไซต์ทั่วโลกของ {name} มาจาก {num} ประเทศทั่วโลกและใช้ {coin} ในการชำระเงิน {coin} เป็นธุรกรรมแบบไร้พรมแดนที่ช่วยให้ทำธุรกรรมได้ทันทีและต้นทุนต่ำทั่วโลกโดยไม่ต้องรอและเสียค่าธรรมเนียมระหว่างประเทศ",
  "custService": "บริการลูกค้า",
  "helpLine": "บริการลูกค้าออนไลน์",
  "contactUs": "ติดต่อเรา",
  "客户端下载": "ดาวน์โหลด",
  "提现方式":"วิธีการถอนเงิน",
  "partner": "ซัพพลายเออร์สหกรณ์",
  "buyRules": "กฎของผู้ซื้อ",
  "sellerRules": "นโยบายของผู้ขาย",
  "returnsAndEx": "ผลตอบแทนและการแลกเปลี่ยน",
  "servicePolicy": "นโยบายการบริการ",
  "returnPolicy": "นโยบายการคืนสินค้า",
  "user_Center": "ศูนย์ผู้ใช้",
  "userReg": "การลงทะเบียนผู้ใช้",
  "orderTrack": "สอบถามสั่งซื้อ",
  "purchageHistory": "ประวัติการซื้อ",
  "myPurse": "กระเป๋าเงินของฉัน",
  "aboutUs": "เกี่ยวกับเรา",
  "Recruitment": "รอคนเก่ง",
  "news": "ข้อมูลข่าวสาร",
  "stateMent": "แถลงการณ์เรื่องทาสสมัยใหม่",
  "binance": "บินานซ์",
  "huobi": "หั่วปี้",
  "okx": "ตกลง",
  "metaMask": "MetaMask",
  "homeBannertips1": "มาเป็นพ่อค้า",
  "homeBannertips2": "ค่าคอมมิชชั่นทั้งหมด",
  "homeBannertips3": "สูงสุด",
  "homeBannerbtn": "เข้าร่วมเดี๋ยวนี้",
  "homeDownloadtips1": "ห้างสรรพสินค้าค้าส่งอีคอมเมิร์ซข้ามพรมแดน",
  "homeDownloadtips2": "ข้อเสนอพิเศษของแบรนด์",
  "homeDownloadtips3": "ลดไม่หยุด",
  "homeDownloadtips4": "ดาวน์โหลดแอนดรอยด์",
  "homeDownloadtips5": "ดาวน์โหลดแอปเปิ้ล",
  "homeDownloadtips6": "สแกนรหัส QR เพื่อดาวน์โหลด APP",
  "homeIconTips1": "ของแท้ 100%",
  "homeIconTips2": "7 วันกลับ",
  "homeIconTips3": "ส่วนลดค่าขนส่ง",
  "homeIconTips4": "การชำระเงินที่ปลอดภัย",
  "headerSearchTips": "กรุณาใส่คีย์เวิร์ดเพื่อค้นหา",
  "collAccount": "โหมดเงินกู้",
  "mine": "ของฉัน.",
  "creditText1": "สินเชื่อเริ่มต้นช่วยแก้ปัญหาการกู้ยืมเงิน",
  "creditText2": "ให้บริการสินเชื่อเริ่มต้นและหมุนเวียนเงินทุน",
  "creditWorry": "เงินกู้ไร้กังวล",
  "creditQuota": "ขีดจำกัดที่ยืดหยุ่น",
  "creditQuotaINFO": "100,000 ถึง 30,000,000 ด้วยวงเงินที่ยืดหยุ่นและไม่มีข้อ จำกัด โดยมีระยะเวลากู้สูงสุดหนึ่งปี",
  "quickLoan": "เงินกู้ด่วน",
  "creditReview": "ผ่านการตรวจสอบอย่างเร็วที่สุดหนึ่งชั่วโมง หากการตรวจสอบผ่าน สินเชื่อจะถูกปล่อยทันที",
  "safe": "ปลอดภัยไร้กังวล",
  "safeInfo": "ไม่มีการจดจำนอง ไม่มีการฝาก ไม่มีการเรียกกลับ เพราะนี่เป็นเรื่องส่วนตัว",
  "about": "เกี่ยวกับเรา",
  "aboutText1": "\"เรามุ่งมั่นที่จะให้บริการทางการเงินสินเชื่อตามปรัชญาการดำเนินธุรกิจ \"\"ลูกค้ารายแรก\"\" มีภารกิจในการแก้ปัญหาการหมุนเวียนเงินทุนของลูกค้า นับตั้งแต่ก่อตั้ง บริษัทได้ช่วยเหลือลูกค้าจำนวนมากในการแก้ปัญหาการหมุนเวียนของเงินทุน\"",
  "aboutText2": "วงเงิน: 100,000-30,000,000, วิธีการชำระคืนที่ยืดหยุ่นพร้อมดอกเบี้ยต่ำ, ไม่มีค่าธรรมเนียมล่วงหน้า, เงินกู้ออนไลน์, ไม่ต้องโทรศัพท์เพื่อตรวจสอบ, ข้อมูลที่เป็นความลับและให้ยืมในวันเดียวกัน",
  "contactUs1": "หากคุณไม่ต้องการยืมเงินจากเพื่อนร่วมระดับของคุณ โปรดติดต่อเรา",
  "committed": "มุ่งมั่นที่จะให้บริการสินเชื่อผู้ประกอบการ",
  "financial": "จัดการกับข้อกังวลทางการเงินของคุณ",
  "partnersTit": "แพลตฟอร์มให้ยืมพันธมิตรออนไลน์",
  "application": "การสมัครสินเชื่อ",
  "applicant": "ผู้สมัคร",
  "actualName": "ชื่อจริง",
  "yourName": "กรุณากรอกชื่อ",
  "term": "ระยะเวลาการกู้ยืม",
  "applicationAmount": "จำนวนเงินที่ขอ",
  "rates": "อัตราดอกเบี้ยเงินกู้",
  "loanMethod": "โหมดเงินกู้",
  "accountB": "ยอดเงินในบัญชี",
  "countryOf": "สัญชาติ",
  "myloan": "เงินกู้ของฉัน",
  "applyLoan": "สมัครสินเชื่อ",
  "loaned": "ยืมตัว",
  "interest": "ดอกเบี้ยค้างรับ",
  "esRepayment": "การชำระคืนโดยประมาณ",
  "loanHistory": "บันทึกการกู้ยืม",
  "applicantDate": "วันรับสมัคร",
  "repayment": "การชำระคืน",
  "cycle": "รอบการชำระคืน",
  "fixedRate": "อัตราดอกเบี้ยคงที่",
  "successLoan": "สินเชื่อสำเร็จ",
  "Reapply": "สมัครใหม่",
  "borrow": "สินเชื่อล้มเหลว",
  "applicantIn": "กำลังดำเนินการสมัคร",
  "repaid": "การชำระคืน",
  "overdue": "ค้างชำระ",
  "estirepay": "การชำระคืนโดยประมาณ",
  "loanDays": "จำนวนวันที่ยืม",
  "reAmount": "จำนวนเงินที่ชำระคืน",
  "repay": "โหมดการชำระคืน",
  "entRepay": "ยืนยันการชำระคืน",
  "foryourmoney": "หากคุณกำลังขาดแคลนทุนทรัพย์ หาแหล่งยืมเงินไม่ได้ หรืออายที่จะยืมเงินเพื่อน ติดต่อเราได้ เรามีบริการอย่างมืออาชีพครบวงจรเพื่อตอบข้อสงสัยของคุณได้ตลอดเวลา เป้าหมายของเราคือการทำให้แต่ละสินเชื่อมีความโปร่งใสเพื่อให้ลูกค้าสามารถใช้งานได้อย่างรวดเร็วและมั่นใจ",
  "onlineApplin": "สมัครออนไลน์",
  "businessloan": "การสมัครขอสินเชื่อเริ่มต้น",
  "selectCountry": "กรุณาเลือกสัญชาติ",
  "selectPeriod": "กรุณาเลือกช่วงเวลา",
  "passPortImg": "เลขประจำตัวประชาชน/เลขที่หนังสือเดินทาง",
  "uploadId": "อัปโหลดรูปถ่ายใบรับรอง / หนังสือเดินทาง",
  "readAndAgree": "ฉันได้อ่านและเห็นด้วย",
  "loanAgree": "สัญญาเงินกู้",
  "submitApplica": "การส่งใบสมัคร",
  "photoExample": "ตัวอย่างการถ่ายภาพ",
  "discounted": "สินค้าลดราคา",
  "days": "วัน",
  "privacyPolicy": "นโยบายความเป็นส่วนตัว",
  "delivery": "จัดส่งและรับของ",
  "checkAgreement": "กรุณาทำเครื่องหมายข้อตกลง!",
  "businessPhone": "เบอร์โทรสำหรับติดต่อเรื่องธุรกิจ",
  "businessEmail": "อีเมลองค์กร",
  "提交失败": "การส่งล้มเหลว",
  "充值金额不能小于1": "จำนวนการเติมเงินต้องไม่ต่ำกว่า 1 (รวมทศนิยม 2 ตำแหน่ง)",
  "请切换其他语言后查看": "โปรดเปลี่ยนไปใช้ภาษาอื่นเพื่อดู",
  "我的购物车": "รถเข็นของฉัน",
  "推荐商品": "สินค้าแนะนำ",
  "猜你喜欢": "เดาว่าคุณชอบมัน",
  "暂无店铺": "ไม่พบร้านค้า",
  "添加失败": "ส่งไม่สำเร็จ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "提交订单": "การส่งคำสั่งซื้อ",
  recommendclass: "แนะนำหมวดหมู่",
  "滑动验证": "การตรวจสอบการเลื่อน",
  "最多上传9张图片": "อัปโหลดรูปภาพได้สูงสุด 9 ภาพ",
  "账号注销": "ยกเลิกบัญชี",
  "确定注销": "ยืนยันการยกเลิก",
  "您的账号": "บัญชีของคุณ",
  "为什么要离开": "ทำไมต้องออก",
  "您还有余额,不能注销账号": "คุณยังมีเงินคงเหลือ ไม่สามารถยกเลิกบัญชีได้",
  "长时间未付款，系统自动取消订单": "ยกเลิกคำสั่งซื้อโดยระบบเนื่องจากไม่ได้ชำระเงินเป็นเวลานาน",
  "请输入注销理由": "โปรดป้อนเหตุผลในการยกเลิก",
  "您确认要注销吗?": "คุณยืนยันที่จะยกเลิกหรือไม่?",
  "我再考虑下": "ฉันกำลังพิจารณาอีกครั้ง",
  "同意注销": "ยอมรับการยกเลิก",
  "注销成功": "ยกเลิกสำเร็จ",
  "App下载(买家端)": "ดาวน์โหลดแอป (ซื้อขาย)",
  "App下载(卖家端)": "ดาวน์โหลดแอป (ขาย)",
  "最多包含10位小数": "สูงสุด 10 ตำแหน่งทศนิยม",
  "企业电话": "โทรศัพท์ธุรกิจ",
  "加密货币": "สกุลเงินที่เข้ารหัส",
  "职业机会": "โปรโมชั่น",
  "银行卡": "บัตรธนาคาร",
  '参数缺失': 'ขาดพารามิเตอร์',
  '充值数量必填': 'จำนวนการเติมเงินจำเป็น',
  "充值币种": "เติมเงินสกุลเงิน",
  "充值金额": "จำนวนเงินที่เติม",
  "充值金额不得小于": "จำนวนเงินที่เติมต้องไม่น้อยกว่า",
  "充值金额不得大于": "จำนวนเงินที่เติมต้องไม่มากกว่า",
  "请先选择币种": "โปรดเลือกสกุลเงินก่อน",
  "开户行": "ธนาคารที่เปิดบัญชี",
  "请输入开户行名称": "โปรดป้อนชื่อธนาคารที่เปิดบัญชี",
  "银行卡号": "หมายเลขบัตรธนาคาร",
  "请输入银行卡号": "โปรดป้อนหมายเลขบัตรธนาคาร",
  "点击去支付": "คลิกเพื่อชำระเงิน",
  "企业证明": "หลักฐานองค์กร",
  footTipTikTok:'ติ๊กต๊อกมอลล์ ©️2024 ลิขสิทธิ์',
  TikTokFoot:'BizSpring Mall เป็นแพลตฟอร์มโซเชียลวิดีโอสั้นระดับโลกอย่าง BizSpring และบริษัทการค้าส่งรายใหญ่ที่สุดในเอเชียอย่าง Alibaba ซึ่งก่อตั้งขึ้นโดยความร่วมมือ เป็นแพลตฟอร์มอีคอมเมิร์ซระดับโลกและมีคลังสินค้าอัจฉริยะที่ดำเนินการด้วยตนเองสามแห่งในโลก ตั้งอยู่ในโตรอนโต แคนาดา ลอสแองเจลิส และชิบะ ประเทศญี่ปุ่น สินค้าที่จำหน่ายในแอปประกอบด้วยสินค้ายอดนิยมจากญี่ปุ่น เกาหลีใต้ จีน และประเทศอื่นๆ ในเอเชีย ปัจจุบันมีจำนวนมากกว่า 50,000 รายและยังคงเติบโตอย่างรวดเร็ว',
  "cancelInfo":"เตือน! โปรดระวังการยกเลิกบัญชี หากคุณไม่ได้ใช้บัญชีอีกต่อไป คุณสามารถคลิก [ตกลงที่จะยกเลิก] คุณอาจไม่สามารถลงทะเบียนได้ภายในสองสามวันหลังจากการยกเลิก"
,
  "getCouponSuccess": "รับสำเร็จ",
  "liveRooms": "ห้องสด",
  "liveStreaming": "สด",
  "notStarted": "ยังไม่เริ่ม",
  "finished": "สิ้นสุด",
  "myPoints": "คะแนนของฉัน",
  "searchGoods": "ค้นหาสินค้า",
  "points": "คะแนน",
  "point": "คะแนน",
  "stock": "สต็อก",
  "spec": "ข้อมูลจำเพาะ",
  "exchangeNow": "แลกตอนนี้",
  "currentPoint": "คะแนนของฉัน",
  "pointNotEnough": "คะแนนไม่เพียงพอ"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "泰语(th)",
    "addImageHint": "(โปรดเพิ่มรูปภาพ)",
    "deleteNode": "ลบ",
    "topPos": "บนสุด {n}",
    "col": "คอลัมน์ {n}",
    "pos": "ตำแหน่ง {n}",
    "decoType_container": "คอนเทนเนอร์",
    "decoType_title": "ข้อความหัวเรื่อง",
    "decoType_richText": "ข้อความเนื้อหา",
    "decoType_notice": "ประกาศ",
    "decoType_blank": "เว้นวรรค",
    "decoType_banner": "แบนเนอร์เลื่อน",
    "decoType_imageSingle": "รูปเดียว",
    "decoType_imageMulti": "หลายรูป",
    "decoType_video": "วิดีโอ",
    "decoType_goodsRecommend": "สินค้าแนะนำ",
    "decoType_goodsSelection": "คัดสรรสินค้า",
    "decoType_seckill": "แฟลชเซล",
    "decoType_groupBuy": "ซื้อแบบกลุ่ม",
    "decoType_coupon": "คูปอง",
    "decoType_searchNav": "เมนูค้นหา",
    "decoType_search": "ช่องค้นหา",
    "decoType_searchBox": "ช่องค้นหา",
    "decoType_categoryNav": "เมนูหมวดหมู่",
    "decoType_goodsCategory": "หมวดหมู่สินค้า",
    "decoType_navIconRow": "ไอคอนนำทาง",
    "decoType_imageScroll": "เลื่อนรูปภาพ",
    "decoType_pageBanner": "แบนเนอร์หน้า",
    "decoType_tabs": "แท็บ",
    "decoType_brand": "แบรนด์",
    "decoType_storeRecommend": "ร้านค้าแนะนำ",
    "decoType_hotSelection": "คัดสรรยอดนิยม",
    "decoType_footerLinkGroup": "ลิงก์ส่วนท้าย",
    "decoType_partnerLogoRow": "พันธมิตร",
    "decoType_icpInfo": "ข้อมูล ICP",
    "decoType_topNavMenu": "เมนูบนสุด",
    "decoType_logoBlock": "โลโก้",
    "decoType_langSwitcher": "ภาษา",
    "decoType_currencySwitcher": "สกุลเงิน",
    "decoType_loginBlock": "เข้าสู่ระบบ",
    "decoType_cartIcon": "ตะกร้า",
    "decoType_messageIcon": "ข้อความ",
    "seckillPrice": "ราคาแฟลชเซล",
    "seckillTag": "แฟลชเซล",
    "seckillCountdown": "เหลือเวลา",
    "seckillNotStarted": "เร็วๆ นี้",
    "seckillRushing": "กำลังขาย",
    "seckillWillStart": "เร็วๆ นี้",
    "seckillBuy": "ซื้อเลย (แฟลชเซล)",
    "groupPrice": "ราคากลุ่ม",
    "groupRequiredNum": "คนจึงครบกลุ่ม",
    "noGroupBuy": "ซื้อคนเดียว",
    "groupRule1": "1. เลือกสินค้า",
    "groupRule2": "2. เริ่มกลุ่ม",
    "groupRule3": "3. ครบกลุ่มแล้วจัดส่ง",
    "marketingMoneyOff": "ลดราคา",
    "marketingFreeShipping": "ส่งฟรี",
    "marketingGift": "ของแถม",
    "marketingCoupon": "คูปอง",
    "marketingGroup": "ซื้อแบบกลุ่ม",
    "marketingSeckill": "แฟลชเซล",
    "marketingExpired": "โปรโมชันหมดอายุ",
    "marketingNotActive": "โปรโมชันยังไม่เริ่ม",
    "alreadyGotCoupon": "รับแล้ว",
    "couponReceived": "รับแล้ว",
    "hotSearch": "ค้นหายอดนิยม:"
}